export const Constant = {
  route: {
    homeBuilder: {
      dashboard: "/",
      login: "/login",
      settings: "/profile",
    },
  },
  role: {
    all: "All",
    superModerator: "Super Moderator",
    moderator: "Moderator",
    sale: "Sale",
    designStudio: "Design Studio",
    homeExplorerUser: "Home Explorer User",
    homeBuilder: "Home Builder",
  },
};

export const convertToFullDateTimeString = (dateString) =>
  new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
